import { render } from "./vbutton.vue?vue&type=template&id=5420071a"
import script from "./vbutton.vue?vue&type=script&lang=js"
export * from "./vbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__